var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgActivity = function SvgActivity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "activity_svg__a",
    d: "M0 0h32v32H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "activity_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#activity_svg__a"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 16,
    cy: 23,
    fill: "#F7F7F7",
    stroke: "#000",
    mask: "url(#activity_svg__b)",
    rx: 11.5,
    ry: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7F7F7",
    d: "M11 17h10v5H11z",
    mask: "url(#activity_svg__b)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 10.5,
    r: 5,
    stroke: "#000",
    mask: "url(#activity_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M15.5 15h1v9h-1z",
    mask: "url(#activity_svg__b)"
  }))));
};
export default SvgActivity;